import type { CodeLookup } from './codebookSource';

/**
 * The one-line label a code chip shows, per lookup state.
 *
 * The three misses read differently ON PURPOSE. A reviewer is deciding whether
 * a code is correct, and "that code does not exist" is a claim we are only
 * entitled to make when a codeset is actually loaded — the previous single
 * "Uncatalogued code" made it on every screen, including deployments where no
 * codeset had ever been mounted.
 */
export function codeTitle(lookup: CodeLookup): string {
  switch (lookup.status) {
    case 'loading':
      return '…';
    case 'found':
      return lookup.entry.title;
    case 'unknown':
      return 'Not in the codeset';
    case 'no-codeset':
      return 'No codeset loaded';
    case 'error':
      return 'Lookup unavailable';
  }
}

/** The longer description, for the detail modal. */
export function codeDescription(lookup: CodeLookup): string {
  switch (lookup.status) {
    case 'loading':
      return 'Looking this code up…';
    case 'found':
      // Falling back to the title rather than to nothing. Not every entry
      // carries a long descriptor — a release whose base file has only a short
      // column, and the built-in modifier and physical-status entries, have
      // just the one string — and an empty block under an "Official
      // descriptor" heading reads as "we have nothing on this code".
      return lookup.entry.desc || lookup.entry.title || '';
    case 'unknown':
      return 'This code is not present in the codeset this deployment has loaded.';
    case 'no-codeset':
      return 'No code reference has been loaded, so this code cannot be looked up. It may still be valid — ask an administrator to mount the codeset volume.';
    case 'error':
      return 'The code reference could not be reached. Try again.';
  }
}
